import { type Theme } from "@mui/material";
import { lighten } from "@mui/system";

interface GetMachineStatusColorParams {
	status: string;
	productionEnabled: boolean;
	theme: Theme;
}

export const getMachineStatusColor = ({ status, productionEnabled, theme }: GetMachineStatusColorParams): string => {
	let color: string;
	const normalizedStatus = status.toLowerCase().trim();

	switch (normalizedStatus) {
		case "initializing":
		case "service":
		case "machineservice":
		case "warning":
		case "paused":
		case "changingcorrugate":
		case "changing corrugate":
		case "machinechangingcorrugate":
			color = theme.palette.warning.light;
			break;
		case "offline":
		case "machineoffline":
			color = theme.palette.info.main;
			break;
		case "error":
		case "machineerror":
			color = theme.palette.error.light;
			break;
		case "online":
		case "machineonline":
			color = !productionEnabled ? theme.palette.warning.light : theme.palette.common.white;
			break;
		default:
			color = theme.palette.common.white;
	}

	return lighten(color, 0.4);
};
